export default [{"url":"https://ogudus.invexerp.io-0.api.invexerp.io","name":"Branch 1","port":"6514","isStore":true,"isHQ":true}]